import { render } from "./FormInputText.vue?vue&type=template&id=f0d2d602"
import script from "./FormInputText.vue?vue&type=script&lang=js"
export * from "./FormInputText.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alex/Documents/Google Ads/Panorama Residence/Panorama web/panorama-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__